import { render, staticRenderFns } from "./CriarCampanha.vue?vue&type=template&id=3f50a466&"
import script from "./CriarCampanha.vue?vue&type=script&lang=js&"
export * from "./CriarCampanha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports